import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

//fetch notification list
export const fetchNotificationListApi = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_NOTIFICATION_DETAILS}?coachId=${coachId}`
  );
  return response?.data;
};

//fetch announcements
export const fetchAnnouncementListApi = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_ANNOUNCEMENT_LIST}/${coachId}`
  );
  return response?.data;
};

//fetch coach profile
export const updateNotificationCountApi = async ({
  coachId,
  isMarkAllRead = false,
  notificationId,
}) => {
  const response = await axiosInstance.post(
    `${Endpoints.UPDATE_NOTIFICATION_COUNT}?coachId=${coachId}${
      notificationId ? `&notificationId=${notificationId}` : ""
    }&isMarkAllRead=${isMarkAllRead}`
  );
  return response?.data;
};
